import { useMemo } from "react";
import type { MyPayEnvironment } from "../../generated/core-api";
import { resolveMyPayEnvironmentLabel } from "./resolveMyPayEnvironmentLabel";
import { useMyPayEnvironments } from "./useMyPayEnvironments";

/**
 * Display label for the bulk-create wizard's selected Datapay environment
 * (#433 step 3 — Results name / code / environment).
 */
export function useMyPayEnvironmentLabel(
  environment: MyPayEnvironment | null | undefined
) {
  const environmentsQuery = useMyPayEnvironments();

  const label = useMemo(
    () => resolveMyPayEnvironmentLabel(environment, environmentsQuery.data),
    [environment, environmentsQuery.data]
  );

  return {
    label,
    environmentsQuery,
  };
}
